import React from "react";
import { Button, message } from "antd";
import { PrinterOutlined, CloseOutlined, WarningOutlined } from "@ant-design/icons";
import useKotPrintFailureStore from "../../../../stores/useKotPrintFailureStore";
import CWKOTPrinter from "../../../../lib/printer/CWKotPrinter";

// BUG-1993/1997/1802 cluster: a failed KOT print used to be a message.error
// toast that auto-dismissed in 5s. The order data was already saved server-side
// by that point - only the physical print failed - so nothing was actually
// lost, but a busy waiter/cashier could easily miss the toast and never know
// there was anything to reprint. This renders one persistent row per failure
// until it's dismissed or reprinted, always visible regardless of which table
// or screen is open.
const KotPrintFailureBanner = () => {
  const failures = useKotPrintFailureStore((s) => s.failures);
  const removeFailure = useKotPrintFailureStore((s) => s.removeFailure);

  if (failures.length === 0) return null;

  const handleReprint = (failure) => {
    try {
      CWKOTPrinter({ items: failure.items, fbOrderId: failure.fbOrderId }, false, false, true);
      message.success(`Reprint sent for ${failure.tableLabel || "order"}`, 3);
    } catch (err) {
      message.error("Reprint failed - try again", 3);
      return;
    }
    removeFailure(failure.id);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9500,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {failures.map((failure) => (
        <div
          key={failure.id}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            padding: "8px 16px",
            backgroundColor: "#A32A1F",
            color: "#fff",
            fontSize: "0.85rem",
            borderBottom: "1px solid rgba(255,255,255,0.25)",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <WarningOutlined />
            KOT print failed{failure.tableLabel ? ` — ${failure.tableLabel}` : ""}
            {failure.productionCenter ? ` (${failure.productionCenter})` : ""}. Kitchen has not received this order.
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Button size="small" icon={<PrinterOutlined />} onClick={() => handleReprint(failure)}>
              Reprint
            </Button>
            <Button
              size="small"
              type="text"
              icon={<CloseOutlined style={{ color: "#fff" }} />}
              onClick={() => removeFailure(failure.id)}
            />
          </span>
        </div>
      ))}
    </div>
  );
};

export default KotPrintFailureBanner;
